import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "form"
};
var _hoisted_2 = {
  class: "form-item"
};
var _hoisted_3 = {
  class: "form-inline"
};
var _hoisted_4 = {
  class: "form-item"
};
var _hoisted_5 = {
  class: "form-item"
};
var _hoisted_6 = {
  class: "form-item"
};
var _hoisted_7 = {
  class: "catalogue-select"
};
var _hoisted_8 = {
  key: 1,
  class: "form-inline"
};
var _hoisted_9 = {
  class: "form-item"
};
var _hoisted_10 = {
  class: "form-item"
};
import { ref, reactive, inject } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { operationRecord } from '../common/common';

/* api */
import { getDictItem, getTutorial, getUnit, copyCourse, editCourse } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'SaveCourseDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var discussId = inject('discussId');
    var emit = __emit;
    var props = __props;
    var formData = reactive({
      name: '',
      type: 0,
      period: null,
      periodList: [{
        label: '全部',
        value: null
      }],
      subject: null,
      subjectList: [{
        label: '全部',
        value: null
      }],
      version: null,
      versionList: [{
        label: '全部版本',
        value: null
      }],
      material: null,
      materialList: [{
        label: '全部教材',
        value: null
      }],
      unit: null,
      unitList: [],
      unitTree: {},
      // 单元选择的1-4类数据
      oneClass: null,
      oneClassList: [{
        label: '全部',
        value: null
      }, {
        label: '身心健康',
        value: 'physical_health'
      }, {
        label: '艺术素养',
        value: 'art_acc'
      }, {
        label: '人文素养',
        value: 'humanity_acc'
      }, {
        label: '科学素养',
        value: 'science_acc'
      }],
      twoClass: null,
      twoClassList: [{
        label: '全部',
        value: null
      }]
    });
    var loading = ref(false);

    /* 事件 */
    // 清空表单数据
    var clearForm = function clearForm() {
      formData.type = 0;
      formData.period = null;
      formData.periodList = [{
        label: '全部',
        value: null
      }];
      formData.subject = null;
      formData.subjectList = [{
        label: '全部',
        value: null
      }];
      formData.version = null;
      formData.versionList = [{
        label: '全部版本',
        value: null
      }];
      formData.material = null;
      formData.materialList = [{
        label: '全部教材',
        value: null
      }];
      formData.unit = null;
      formData.unitList = [];
      formData.unitTree = {};
      formData.oneClass = null;
      formData.twoClass = null;
      formData.twoClassList = [{
        label: '全部',
        value: null
      }];
      loading.value = false;
    };

    // 获取字典数据
    var getSelectList = function getSelectList(code, key) {
      var allLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '全部';
      var listKey = "".concat(key, "List");
      getDictItem(code).then(function (res) {
        if (res.data.code === 0) {
          var list = res.data.data || [];
          formData[listKey] = list.map(function (e) {
            return {
              value: e.code,
              label: e.displayName
            };
          });
          formData[listKey].unshift({
            value: null,
            label: allLabel
          });
          var index = formData[listKey].findIndex(function (e) {
            return e.value === formData[key];
          });
          if (index === -1) {
            formData[key] = null;
          }
        }
      });
    };

    // 获取教材
    var getTutorialList = function getTutorialList() {
      var data = {
        periodDictItemCode: formData.period,
        subjectDictItemCode: formData.subject,
        versionDictItemCode: formData.version
      };
      getTutorial(data).then(function (res) {
        if (res.data.code === 0) {
          var list = res.data.data || [];
          formData.materialList = list.map(function (e) {
            return {
              value: e.id,
              label: e.name
            };
          });
          formData.materialList.unshift({
            value: null,
            label: '全部教材'
          });
          var index = formData.materialList.findIndex(function (e) {
            return e.value === formData.material;
          });
          if (index === -1) {
            formData.material = null;
            getUnitList();
          }
        }
      });
    };

    // 获取单元
    var getUnitList = function getUnitList() {
      formData.unit = null;
      if (formData.material) {
        getUnit(formData.material).then(function (res) {
          if (res.data.code === 0) {
            var list = res.data.data || [];
            formData.unitList = list;
          }
        });
      } else {
        formData.unitList = [];
      }
    };

    // 关闭事件
    var handleClose = function handleClose() {
      clearForm();
      emit('update:visible', false);
    };

    // 打开事件
    var handleOpen = function handleOpen() {
      getSelectList('period', 'period');
      getSelectList('subject', 'subject');
      getSelectList('tutorial_version', 'version', '全部版本');
      getTutorialList();
    };

    // 选择单元
    var selectUnit = function selectUnit(val, _ref2, extra) {
      var node = _ref2.node;
      var TutorialDirObj = [{
        label: 'firstTutorialDirName',
        value: 'firstTutorialDirId'
      }, {
        label: 'secondTutorialDirName',
        value: 'secondTutorialDirId'
      }, {
        label: 'threeTutorialDirName',
        value: 'threeTutorialDirId'
      }, {
        label: 'fourTutorialDirName',
        value: 'fourTutorialDirId'
      }];
      var _setTutorialDir = function setTutorialDir(node) {
        var updateObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          firstTutorialDirId: null,
          firstTutorialDirName: '',
          secondTutorialDirId: null,
          secondTutorialDirName: '',
          threeTutorialDirId: null,
          threeTutorialDirName: '',
          fourTutorialDirId: null,
          fourTutorialDirName: ''
        };
        var label = node.label,
          value = node.value,
          level = node.level,
          parent = node.parent;
        if (label && value) {
          updateObj[TutorialDirObj[level].label] = label;
          updateObj[TutorialDirObj[level].value] = value;
          if (parent) {
            _setTutorialDir(parent, updateObj);
          }
        }
        return updateObj;
      };
      /* firstTutorialDirId: 0, // 第一级教材目录ID
        firstTutorialDirName: 'string', // 第一级教程目录名称
        secondTutorialDirId: 0, // 第二级教材目录ID
        secondTutorialDirName: 'string', // 第二级教程目录名称
        threeTutorialDirId: 0, // 第三级教材目录ID
        threeTutorialDirName: 'string', // 第三级教程目录名称
        fourTutorialDirId: 0, // 第四级教材目录ID
        fourTutorialDirName: 'string', // 第四级教程目录名称 */

      if (val) {
        var currentNode = node['__tdesign_tree-node__'];
        formData.unitTree = _setTutorialDir(currentNode);
      } else {
        formData.unitTree = {
          firstTutorialDirId: null,
          firstTutorialDirName: '',
          secondTutorialDirId: null,
          secondTutorialDirName: '',
          threeTutorialDirId: null,
          threeTutorialDirName: '',
          fourTutorialDirId: null,
          fourTutorialDirName: ''
        };
      }
    };

    // 复制学程
    var copy = function copy() {
      return new Promise(function (resolve) {
        copyCourse(props.courseId).then(function (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          }
        });
      });
    };

    // 修改学程
    var edit = function edit(cId) {
      return new Promise(function (resolve) {
        var getLabel = function getLabel(key) {
          var _formData$listKey;
          var listKey = "".concat(key, "List");
          var label = (_formData$listKey = formData[listKey]) === null || _formData$listKey === void 0 || (_formData$listKey = _formData$listKey.find(function (e) {
            return e.value === formData[key];
          })) === null || _formData$listKey === void 0 ? void 0 : _formData$listKey.label;
          return label.includes('全部') ? '' : label;
        };
        var data = {
          id: cId,
          catalog: {
            id: cId,
            courseId: cId
          }
        };
        var cataMore = {};
        if (formData.type === 0) {
          // 国家课程
          cataMore = _objectSpread({
            resourceTypeDictItemCode: 'nation',
            periodDictItemName: getLabel('period'),
            periodDictItemCode: formData.period,
            subjectDictItemName: getLabel('subject'),
            subjectDictItemCode: formData.subject,
            tutorialVersionDictItemName: getLabel('version'),
            tutorialVersionDictItemCode: formData.version,
            tutorialName: getLabel('material'),
            tutorialId: formData.material
          }, formData.unitTree);
        } else {
          // 特色课程
          cataMore = {
            resourceTypeDictItemCode: 'specialty',
            firstDirDictItemName: getLabel('oneClass'),
            firstDirDictItemCode: formData.oneClass,
            secondDirDictItemName: getLabel('twoClass'),
            secondDirDictItemCode: formData.twoClass
          };
        }
        data.catalog = _objectSpread(_objectSpread({}, data.catalog), cataMore);
        editCourse(data).then(function (res) {
          if (res.data.code === 0) {
            MessagePlugin.success('已保存至“创作中心”的“创作”中！');
            operationRecord(discussId.value, '保存学程');
            resolve();
          }
        });
      });
    };

    // 弹窗确定
    var handleSure = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var cId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              loading.value = true;
              _context.n = 1;
              return copy();
            case 1:
              cId = _context.v;
              _context.n = 2;
              return edit(cId);
            case 2:
              loading.value = false;
              handleClose();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleSure() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_radio = _resolveComponent("t-radio");
      var _component_t_radio_group = _resolveComponent("t-radio-group");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_tree_select = _resolveComponent("t-tree-select");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        class: "save-course-dialog",
        visible: props.visible,
        closeOnOverlayClick: false,
        confirmLoading: loading.value,
        header: "保存至创作中心",
        width: "480px",
        attach: "body",
        onClose: handleClose,
        onOpened: handleOpen,
        onConfirm: handleSure
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "must"
          }, "资源类型", -1)), _createVNode(_component_t_radio_group, {
            modelValue: formData.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return formData.type = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_radio, {
                value: 0
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[9] || (_cache[9] = [_createTextVNode("国家课程", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_radio, {
                value: 1
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[10] || (_cache[10] = [_createTextVNode("特色课程", -1)]));
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])]), formData.type === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("span", null, "学段", -1)), _createVNode(_component_t_select, {
            modelValue: formData.period,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return formData.period = $event;
            }),
            options: formData.periodList,
            onChange: getTutorialList
          }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("span", null, "学科", -1)), _createVNode(_component_t_select, {
            modelValue: formData.subject,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return formData.subject = $event;
            }),
            options: formData.subjectList,
            onChange: getTutorialList
          }, null, 8, ["modelValue", "options"])])]), _createElementVNode("div", _hoisted_6, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "目录", -1)), _createElementVNode("div", _hoisted_7, [_createVNode(_component_t_select, {
            class: "catalogue-item",
            modelValue: formData.version,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return formData.version = $event;
            }),
            options: formData.versionList,
            onChange: getTutorialList
          }, null, 8, ["modelValue", "options"]), _createVNode(_component_t_select, {
            class: "catalogue-item",
            modelValue: formData.material,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return formData.material = $event;
            }),
            options: formData.materialList,
            onChange: getUnitList
          }, null, 8, ["modelValue", "options"]), _createVNode(_component_t_tree_select, {
            class: "catalogue-item",
            modelValue: formData.unit,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return formData.unit = $event;
            }),
            data: formData.unitList,
            keys: {
              label: 'name',
              value: 'id',
              children: 'children'
            },
            placeholder: "请选择单元",
            onChange: selectUnit
          }, null, 8, ["modelValue", "data"])])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "一类", -1)), _createVNode(_component_t_select, {
            modelValue: formData.oneClass,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return formData.oneClass = $event;
            }),
            options: formData.oneClassList,
            onChange: _cache[7] || (_cache[7] = function ($event) {
              return getSelectList(formData.oneClass, 'twoClass');
            })
          }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_10, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "二类", -1)), _createVNode(_component_t_select, {
            modelValue: formData.twoClass,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return formData.twoClass = $event;
            }),
            options: formData.twoClassList
          }, null, 8, ["modelValue", "options"])])]))])];
        }),
        _: 1
      }, 8, ["visible", "confirmLoading"]);
    };
  }
};